import { Download, Image as ImageIcon, Paperclip } from 'lucide-react';
import { cn } from '../lib/cn.js';

/**
 * De bijlage-rij van de berichtkaart (home-spec §9.5), gedeeld met het gesprek (berichten-spec
 * §4.2).
 *
 * **Waarom dit in twee stukken komt.** De rij ziet er op beide plaatsen hetzelfde uit en doet er
 * iets anders: op de tijdlijn is hij een verwijzing naar het bericht, in een gesprek opent hij het
 * bestand. Een component die allebei probeert te zijn, krijgt een `to`- én een `onOpen`-prop en
 * een `if` die bepaalt welk element het wordt — en dan staat de helft van de rij in de ene en de
 * helft in de andere tak.
 *
 * Daarom: `attachmentRowClass` is de omlijsting en `AttachmentRowBody` de inhoud. De aanroeper
 * kiest zelf of hij er een `<Link>` of een `<button>` omheen zet; het uiterlijk staat één keer.
 */
export const attachmentRowClass =
  'flex items-center gap-2.5 rounded-md border border-border-light bg-background px-3 py-2 text-left transition-colors hover:border-brand-primary hover:bg-brand-primary-tint';

export interface AttachmentRowBodyProps {
  name: string;
  /** De regel eronder: grootte, aantal, soort. Leeg laten mag. */
  meta?: string | null;
  isImage?: boolean;
  className?: string;
}

export function AttachmentRowBody({ name, meta, isImage, className }: AttachmentRowBodyProps) {
  return (
    <>
      <span
        aria-hidden
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-sm bg-brand-dark-blue-tint text-brand-dark-blue"
      >
        {isImage ? <ImageIcon className="h-4 w-4" /> : <Paperclip className="h-4 w-4" />}
      </span>
      <span className={cn('min-w-0 flex-1', className)}>
        <span className="block truncate font-heading text-small font-medium text-text-primary">
          {name}
        </span>
        {meta ? (
          <span className="block text-micro tracking-normal text-text-muted">{meta}</span>
        ) : null}
      </span>
      <Download aria-hidden className="h-4 w-4 shrink-0 text-text-muted" />
    </>
  );
}
